import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/css/reset.css';
import './styles/css/index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

serviceWorkerRegistration.register();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>

    <App />
  </React.StrictMode>
);
